import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame, Eye } from "lucide-react";
import { API_URL } from "../config";
import { useSpecialty } from "../SpecialtyContext";

const KIND_LABEL = { post: "Статья", case: "Случай", lecture: "Материал" };
const KIND_PATH = { post: "articles", case: "cases", lecture: "lectures" };

export default function PopularWidget({ global = false }) {
  const [items, setItems] = useState([]);
  const { specialty } = useSpecialty();

  useEffect(() => {
    const params = new URLSearchParams({ limit: 6 });
    if (!global && specialty?.id) params.set("specialty", specialty.id);
    fetch(`${API_URL}/popular?${params}`)
      .then(r => r.ok ? r.json() : [])
      .then(setItems)
      .catch(() => setItems([]));
  }, [specialty, global]);

  if (items.length === 0) return null;

  return (
    <div className="card" style={{ marginBottom: 20, background: "#fff1f6", border: "1.5px solid #ffc2d9" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 7, fontWeight: 700, color: "#9c0040", fontSize: "0.95rem", marginBottom: 10 }}>
        <Flame size={16} strokeWidth={2.2} /> Популярное
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {items.map(i => (
          <Link key={`${i.kind}-${i.id}`} to={`/${KIND_PATH[i.kind]}/${i.id}`}
            style={{ display: "flex", alignItems: "center", gap: 8, textDecoration: "none", fontSize: "0.9rem" }}>
            <span style={{
              background: "#006870", color: "#fff", borderRadius: 4, padding: "1px 7px",
              fontSize: "0.72rem", fontWeight: 700, flexShrink: 0,
            }}>{KIND_LABEL[i.kind]}</span>
            <span style={{ color: "#333", flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {i.title}
            </span>
            <span style={{ display: "inline-flex", alignItems: "center", gap: 3, color: "#aaa", fontSize: "0.8rem", flexShrink: 0 }}>
              <Eye size={13} strokeWidth={2} /> {i.views}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
